<footer #footer class=" w-full min-w-0 p-20 pt-4">
  <div>
    <div id="footer_copyright"> 
      <span data-i18n="Copyright footer">
      Note: This is not an exact copy of the production user interface or PSU authentication journey.For the purposes of our sandbox journeys, we've implemented a standard AIS consent authorisation journey for all brands. This may differ from our production journeys in terms of the data displayed and the specific credentials required.
      </span>
    </div>
  </div>
</footer>
